import { useCallback, useRef } from 'react';

import { SolidMetadata } from 'core/interfaces/billing';
import { OneTimePaymentArgs } from 'core/one-time/constans/types';

interface UseOneClickPaymentProps {
  metadata?: any;
  solidMetadata?: SolidMetadata;
}

interface OneClickArgsExtended extends OneTimePaymentArgs {
  attemptsCount: number;
  scenario?: '3ds' | 'funds';
  metadata?: any;
  solidMetadata?: SolidMetadata;
}

export const useOneClickPayment = ({ metadata, solidMetadata }: UseOneClickPaymentProps) => {
  const oneClickArgs = useRef<OneClickArgsExtended>({
    attemptsCount: 0,
  } as OneClickArgsExtended);

  const updateOneClickArgs = useCallback(
    (args: OneTimePaymentArgs) => {
      oneClickArgs.current = {
        ...args,
        attemptsCount: 0,
        scenario: undefined,
        metadata,
        solidMetadata,
      };
    },
    [metadata, solidMetadata]
  );

  const getOneClickArgs = () => oneClickArgs.current;

  const incrementAttempts = () => {
    oneClickArgs.current.attemptsCount += 1;
  };

  return {
    oneClickArgs: oneClickArgs.current,
    updateOneClickArgs,
    getOneClickArgs,
    incrementAttempts,
  };
};
